// TODO: From customer-center; What we can leverage? What is needed to add for OSC?
import { configureStore } from '~/org/twilio/platform/managed-redux-store';
// import {
//   ACCOUNT_FEATURE_KEY,
//   accountReducer,
//   APPCONTEXT_FEATURE_KEY,
//   appContextReducer,
//   AUTH_FEATURE_KEY,
//   authReducer,
//   REGIONAL_FEATURE_KEY,
//   regionalReducer,
//   SEARCH_FEATURE_KEY,
//   searchReducer,
//   USER_FEATURE_KEY,
//   userReducer,
// } from "~/org/twilio/one-admin/shared/data-access-one-admin-shared-state";

import {
  SEARCH_RESULTS_FEATURE_KEY,
  searchResultsReducer,
} from './searchResults.slice';

import {
  SEARCH_VALUE_FEATURE_KEY,
  searchValueReducer,
} from './searchValue.slice';

export const reduxStore = configureStore({
  reducer: {
    // From One Admin
    // [APPCONTEXT_FEATURE_KEY]: appContextReducer,
    // [AUTH_FEATURE_KEY]: authReducer,
    // [REGIONAL_FEATURE_KEY]: regionalReducer,
    // [SEARCH_FEATURE_KEY]: searchReducer,
    // [USER_FEATURE_KEY]: userReducer,
    // [ACCOUNT_FEATURE_KEY]: accountReducer,
    // OSC
    [SEARCH_RESULTS_FEATURE_KEY]: searchResultsReducer,
    [SEARCH_VALUE_FEATURE_KEY]: searchValueReducer,
  },
  devTools: true,
});
